import { React, useState } from "react";
export const Faqs = () => {
  // State to manage which FAQ is open
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    // If the clicked item is already open, close it. Otherwise, open it.
    setOpenIndex(openIndex === index ? null : index);
  };

  // Array of FAQ questions and answers
  const faqs = [
    {
      question:
        "Who is eligible to participate in the Predict and Win Contest?",
      answer: [
        {
          keyPoint: "All subscribers who are currently not active on any plan.",
        },
        {
          keyPoint:
            "Users who have registered on VZY, but have never subscribed to a VZY plan.",
        },
      ],
    },
    {
      question: "How long are the coupons valid?",
      answer:
        "Coupons are valid till six months after the Champions Trophy 2025 ends (i.e. till 9th Sep 2025).",
    },
    {
      question: "How can I redeem my coupons?",
      answer:
        "To redeem a coupon - Log-in to the vzy website or app, navigate to the ‘Plans and Offers’ page, select your desired plan, enter your coupon code in the ‘Add a Coupon’ section at checkout.",
    },
    {
      question: "Can I use multiple coupons at once?",
      answer: "No, only one coupon can be applied per transaction.",
    },
    {
      question: "Can I share my coupon with friends or family?",
      answer: "Yes, the coupon can be gifted to your friends and family.",
    },
    {
      question: "Can I participate in the contest multiple times?",
      answer:
        "A user can enter the contest only once per match using their mobile number. However, they are welcome to participate in every India match.",
    },
  ];

  return (
    <>
      <div className="championsTrofyFaqContainer" id="faqs">
        <div className="container">
          <div className="championsTrofyfaqHeading">FAQ’s</div>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`championsTrofy-faq-item ${openIndex === index ? "active" : ""}`}
            >
              <div
                className="championsTrofy-faq-question"
                onClick={() => handleToggle(index)}
              >
                <span>{faq.question}</span>
                <i className="fas fa-chevron-down"></i>
              </div>
              {openIndex === index && (
                <div className="championsTrofy-faq-answer">
                  {typeof faq.answer == "string" ? (
                    <p>{faq.answer}</p>
                  ) : (
                    <ul className="bulletPoints">
                      {faq.answer.map((item, index) => (
                        <li key={index}>{item.keyPoint}</li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
